import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { CCard, CCardText, CCol, CRow, CFormSelect, CFormLabel, CCardTitle, CForm, CTooltip, CFormCheck } from "@coreui/react";
import { useEffect, useState, useRef } from "react";
import CookieFunctions from "../functions/CookieFunctions";
import { Typeahead } from 'react-bootstrap-typeahead';

export default function ManagerCalendar() {
    const [requests, setRequests] = useState(null)
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [driverOptions, setDriverOptions] = useState([]);
    const [driverId, setDriverId] = useState(null);
    const [myDrivers, setMyDrivers] = useState(false);
    const [terminalDrivers, setTerminalDrivers] = useState(false);
    const [supervisorColors, setSupervisorColors] = useState(null);
    const [teamleader, setTeamleader] = useState(null);
    const [tlOptions, setTlOptions] = useState([]);
    const search = useRef();

    function getRequests(by, status, id = null) {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

        const formData = new FormData();

        let url;
        let method;

        // terminal, teamleader, driver
        switch (by) {
            case "driver":
                url = `/api/manager/${id}/approved/requests`;
                method = 'GET'
                break;
            default: // currently only terminal or teamleader
                url = `api/manager/${by}/${status}/requests`;
                if (id) formData.append("teamleader", id.trim())
                method = 'POST'
        }

        let headers;
        switch (method) {
            case "GET":
                headers = { headers: myHeaders, method: method, }
                break;
            case "POST":
                headers = { headers: myHeaders, method: method, body: formData }
                break;
            default:

        }

        fetch(url, headers).then((res) => {
            if (res.ok) {
                return res.json()
            } else {
                throw new Error()
            }
        }).then((data) => {
            const requestsBySupervisor = new Map();

            data.forEach((req) => {
                const supervisor = req.supervisor;
                if (!requestsBySupervisor.has(supervisor)) {
                    requestsBySupervisor.set(supervisor, []);
                }
                requestsBySupervisor.get(supervisor).push(req);
            });

            // Generate unique colors for each Supervisor
            const supervisorColors = new Map();
            requestsBySupervisor.forEach((requests, supervisor) => {
                const color = getRandomDarkColor();
                supervisorColors.set(supervisor, color);
            });

            // Generate events with color-coded groups
            const events = [];
            requestsBySupervisor.forEach((requests, supervisor) => {
                const color = supervisorColors.get(supervisor);
                requests.forEach((req) => {
                    const event = {
                        ...req,
                        groupId: supervisor,
                        title: req.employeeName,
                        start: req.startDate,
                        end: parseFloat(req.duration) > 1 ? new Date(req.endDate).setSeconds(new Date(req.endDate).getSeconds() + 1) : req.endDate,
                        allDay: parseFloat(req.duration) >= 1,
                        color: color,
                        comments: req.CommentsToTMW,
                        location: req.VacationLocation,
                        supervisor: req.supervisor
                    };
                    events.push(event);
                });
            });

            setRequests(events);
            setSupervisorColors(supervisorColors);
        })
    }

    const fetchDrivers = () => {
        if ((CookieFunctions.getRole().includes('admin'))) {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            fetch("/api/admin/driver", {
                headers: myHeaders,
                method: 'GET'
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error();
                    }
                })
                .then((data) => {
                    setDriverOptions(data);
                    setIsLoading(false);
                })
                .catch((e) => {
                    setError("Error occurred while fetching drivers.");
                    setIsLoading(false);
                });
        } else {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            fetch("/api/manager/getAllDrivers", {
                headers: myHeaders,
                method: 'GET'
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error();
                    }
                })
                .then((data) => {
                    setDriverOptions(data);
                    setIsLoading(false);
                })
                .catch((e) => {
                    setError("Error occurred while fetching drivers.");
                    setIsLoading(false);
                });
        }

    };

    const fetchTeamleaders = () => {

        if ((CookieFunctions.getRole().includes('admin'))) {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            fetch("/api/admin/teamleaders", {
                headers: myHeaders,
                method: 'GET'
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error();
                    }
                })
                .then((data) => {
                    setTlOptions(data);
                    setIsLoading(false);
                })
                .catch((e) => {
                    setError("Error occurred while fetching teamleaders.");
                    setIsLoading(false);
                });
        } else {
            setIsLoading(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', 'Bearer ' + CookieFunctions.getJWTToken());

            fetch("/api/manager/TLByTerminal", {
                headers: myHeaders,
                method: 'GET'
            })
                .then((res) => {
                    if (res.ok) {
                        return res.json();
                    } else {
                        throw new Error();
                    }
                })
                .then((data) => {
                    setTlOptions(data);
                    setIsLoading(false);
                })
                .catch((e) => {
                    setError("Error occurred while fetching teamleaders.");
                    setIsLoading(false);
                });
        }
    };

    const handleDriverSelection = (selected) => {
        if (selected.length === 1) {
            setDriverId(selected[0].mpp_id);
            setMyDrivers(false)
            setTerminalDrivers(false)
            getRequests("driver", "approved", selected[0].mpp_id)
        }
    };


    const handleTLSelection = (selected) => {
        if (selected.length === 1) {
            setTeamleader(selected[0].email);
            setMyDrivers(false)
            setTerminalDrivers(false)
            getRequests("teamleader", "approved", selected[0].email)
        }
    };

    function handleShowMyDrivers(show) {
        setMyDrivers(show)
        if (show) {
            setDriverId(null)
            setTeamleader(null)
            getRequests("teamleader", "approved")
        } else {
            setRequests([])
        }
    }

    function handleShowTerminalDrivers(show) {
        setTerminalDrivers(show)
        if (show) {
            setDriverId(null)
            setTeamleader(null)
            getRequests("terminal", "approved")
        } else {
            setRequests([])
        }
    }

    const eventContent = (arg) => {

        const tooltipStyle = {
            fontSize: '16px',
            padding: '10px'
        };

        const tooltipContent = (
            <>
                <div>TMW Comments: {arg.event.extendedProps.commentsToTMW !== "" ? arg.event.extendedProps.commentsToTMW : "N/A"}</div>
                <div>Drivers Comments: {arg.event.extendedProps.employeeComments !== "" ? arg.event.extendedProps.employeeComments : "N/A"}</div>
                <div>Start Location: {arg.event.extendedProps.vacationLocation !== "" ? arg.event.extendedProps.vacationLocation : "N/A"}</div>
            </>
        )

        const tooltip = (
            <div>
                <CTooltip
                    content={tooltipContent}
                    placement="top"
                    style={tooltipStyle}>
                    <div>{arg.event.title}</div>
                </CTooltip>
            </div>
        );
        return tooltip;
    };

    const ColorLegend = ({ supervisorColors }) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <h4 style={{ marginRight: '10px' }}>Supervisor</h4>
                {Array.from(supervisorColors.entries()).map(([supervisor, color]) => (
                    <div key={supervisor} style={{ display: 'flex', alignItems: 'center', marginRight: '20px', marginBottom: '5px' }}>
                        <span style={{ backgroundColor: color, width: '20px', height: '20px', display: 'inline-block', marginRight: '5px' }}></span>
                        <span>{supervisor}</span>
                    </div>
                ))}
            </div>
        );
    };

    function getRandomDarkColor() {
        // Generate random RGB values in the moderately dark color range
        const r = Math.floor(Math.random() * 128) + 64; // Starting from 64 to avoid very dark shades
        const g = Math.floor(Math.random() * 128) + 64; // Starting from 64 to avoid very dark shades
        const b = Math.floor(Math.random() * 128) + 64; // Starting from 64 to avoid very dark shades

        // Convert RGB to hexadecimal color representation
        const color = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

        return color;
    }

    useEffect(() => {
        fetchDrivers();
        fetchTeamleaders();
    }, []);

    return (

        <CCard className="p-4">
            <CForm className='fs-4'>
                <CRow>
                    <CCol sm="4" xs="6">
                        <CFormLabel className='fs-4'>Search by Driver Name</CFormLabel>
                        <Typeahead
                            id="manager-search"
                            isLoading={isLoading}
                            labelKey={option => `${option.mpp_firstname} ${option.mpp_lastname} (${option.driver_type === "CO" ? option.mpp_id : option.trc_number})`}
                            onChange={handleDriverSelection}
                            options={driverOptions}
                            ref={search}
                        />
                    </CCol>
                    <CCol sm="4" xs="6">
                        <CFormLabel className='fs-4'>Search by Team Leader</CFormLabel>
                        <Typeahead
                            id="tl-search"
                            isLoading={isLoading}
                            labelKey={tlOptions => `${tlOptions.employeeName}`}
                            onChange={handleTLSelection}
                            options={tlOptions}
                            ref={search}
                        />
                    </CCol>
                </CRow>
                <CRow className="my-2">
                    <CCol sm="4">
                        <CFormCheck className='fs-4' label="Show my Drivers" checked={myDrivers} onChange={(e) => { handleShowMyDrivers(e.target.checked) }} disabled={(terminalDrivers) ? true : false} />
                    </CCol>
                    <CCol sm="4">
                        <CFormCheck className='fs-4' label="Show My Terminal Drivers" checked={terminalDrivers} onChange={(e) => { handleShowTerminalDrivers(e.target.checked) }} disabled={(myDrivers) ? true : false} />
                    </CCol>
                </CRow>

                {error && <p>{error}</p>}
            </CForm>
            <br />
            {requests && (
                <>
                    {terminalDrivers && supervisorColors && <ColorLegend supervisorColors={supervisorColors} />}
                    <FullCalendar
                        initialView="dayGridMonth"
                        plugins={[dayGridPlugin]}
                        events={requests}
                        displayEventEnd="true"
                        eventColor={"#" + Math.floor(Math.random() * 16777215).toString(16)}
                        eventContent={eventContent}

                    />

                    <CCardText style={{ display: 'flex', justifyContent: "end" }}>*Note: Calendar only shows  Approved and Pending Cancellation requests up to 6 months in the past</CCardText>
                </>
            )}
        </CCard>
    )
}